import { detectOverflow } from '@popperjs/core';
export var isIntersectingModifier = {
  name: 'is-intersecting-modifier',
  enabled: true,
  phase: 'main',
  requires: ['preventOverflow'],
  fn: function fn(_ref) {
    var state = _ref.state,
      name = _ref.name;
    var popperRect = state.rects.popper;
    var popperAltOverflow = detectOverflow(state, {
      altBoundary: true
    });
    var isIntersectingTop = popperAltOverflow.top < popperRect.height && popperAltOverflow.top > 0;
    var isIntersectingBottom = popperAltOverflow.bottom < popperRect.height && popperAltOverflow.bottom > 0;
    var isIntersecting = isIntersectingTop || isIntersectingBottom;
    state.modifiersData[name] = {
      isIntersecting: isIntersecting
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
      'data-popper-is-intersecting': isIntersecting
    });
  }
};
//# sourceMappingURL=isIntersectingModifier.js.map
